import React, { useEffect, useRef } from "react";
import "./Dialog.scss";

interface Props {
	children: React.ReactNode;
	showModal?: VoidFunction;
	hideModal: VoidFunction;
	hasDivider?: boolean;
}

const DialogHeader: React.FC<Props> = ({
	children,
	showModal,
	hideModal,
	hasDivider = true,
}) => {
	const headerRef = useRef<HTMLDivElement | null>(null);

	return (
		<div className="Dialog--header ion-no-border" ref={headerRef}>
			<div className="Dialog--dragIndicator" />
			{children}
			{hasDivider && <div className="Dialog--headerDivider" />}
		</div>
	);
};
export default DialogHeader;
